/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuaranteeBeneficiaryDto } from './GuaranteeBeneficiaryDto';
import {
    GuaranteeBeneficiaryDtoFromJSON,
    GuaranteeBeneficiaryDtoFromJSONTyped,
    GuaranteeBeneficiaryDtoToJSON,
    GuaranteeBeneficiaryDtoToJSONTyped,
} from './GuaranteeBeneficiaryDto';

/**
 * Beneficiaries breakdown for a guarantee (insurer, co-insurers, re-insurers)
 * @export
 * @interface GuaranteeBeneficiariesDto
 */
export interface GuaranteeBeneficiariesDto {
    /**
     * 
     * @type {GuaranteeBeneficiaryDto}
     * @memberof GuaranteeBeneficiariesDto
     */
    insurer: GuaranteeBeneficiaryDto;
    /**
     * 
     * @type {Array<GuaranteeBeneficiaryDto>}
     * @memberof GuaranteeBeneficiariesDto
     */
    coInsurers: Array<GuaranteeBeneficiaryDto>;
    /**
     * 
     * @type {Array<GuaranteeBeneficiaryDto>}
     * @memberof GuaranteeBeneficiariesDto
     */
    reInsurers: Array<GuaranteeBeneficiaryDto>;
}

/**
 * Check if a given object implements the GuaranteeBeneficiariesDto interface.
 */
export function instanceOfGuaranteeBeneficiariesDto(value: object): value is GuaranteeBeneficiariesDto {
    if (!('insurer' in value) || value['insurer'] === undefined) return false;
    if (!('coInsurers' in value) || value['coInsurers'] === undefined) return false;
    if (!('reInsurers' in value) || value['reInsurers'] === undefined) return false;
    return true;
}

export function GuaranteeBeneficiariesDtoFromJSON(json: any): GuaranteeBeneficiariesDto {
    return GuaranteeBeneficiariesDtoFromJSONTyped(json, false);
}

export function GuaranteeBeneficiariesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeBeneficiariesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insurer': GuaranteeBeneficiaryDtoFromJSON(json['insurer']),
        'coInsurers': ((json['coInsurers'] as Array<any>).map(GuaranteeBeneficiaryDtoFromJSON)),
        'reInsurers': ((json['reInsurers'] as Array<any>).map(GuaranteeBeneficiaryDtoFromJSON)),
    };
}

export function GuaranteeBeneficiariesDtoToJSON(json: any): GuaranteeBeneficiariesDto {
    return GuaranteeBeneficiariesDtoToJSONTyped(json, false);
}

export function GuaranteeBeneficiariesDtoToJSONTyped(value?: GuaranteeBeneficiariesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insurer': GuaranteeBeneficiaryDtoToJSON(value['insurer']),
        'coInsurers': ((value['coInsurers'] as Array<any>).map(GuaranteeBeneficiaryDtoToJSON)),
        'reInsurers': ((value['reInsurers'] as Array<any>).map(GuaranteeBeneficiaryDtoToJSON)),
    };
}

